import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const OrderDayForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const options = new Array(31)
    .fill(1)
    .map((_, i) => ({ label: `${i + 1}`.padStart(2, "0"), value: i + 1 }));

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderDay}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
